module.exports = __webpack_public_path__ + "img/product_01.a58d4ca5.png";